<section class="styling-get-started">
    <h2>Getting started with styling</h2>
    <p>
        Follow these steps to start using ADS styling tokens from
        <a
            [href]="stylingPackageLink"
            target="_blank"
            rel="noopener noreferrer"
        >
            @uilab/styling.
        </a>
    </p>
    <p>
        @uilab/styling is a dependency of
        <a
            [href]="ngMatComponentsPackageLink"
            target="_blank"
            rel="noopener noreferrer"
            >{{ ngMatComponentsPackage }}</a
        >
        and
        <a
            [href]="angularMaterialThemePackageLink"
            target="_blank"
            rel="noopener noreferrer"
            >@uilab/angular-material-theme</a
        >, so it is installed automatically when you install either of those
        packages.
    </p>
    <p>
        For component setup guidance, see the {{ ngMatComponentsPackage }}
        <a [routerLink]="[componentsGetStartedLink]">Getting Started</a> page.
    </p>

    <h3>Step 1: Connect to feed</h3>
    <p
        >Follow the Azure instructions to add a .npmrc file that enables access
        to our private artifact registry.</p
    >
    <p
        >When prompted to choose how to connect to the feed, select npm to view
        the step-by-step setup guide.</p
    >

    <h3>Step 2: Install the package</h3>
    <p>Install the styling package with npm.</p>
    <pre><code [highlight]="installCommand" [language]="'bash'"></code></pre>

    <h3>Step 3: Add styling CSS files</h3>
    <p>
        Add the light and dark CSS variable files to the styles array in
        angular.json or equivalent file.
    </p>
    <pre>
<code [highlight]="angularJsonStylesSnippet" [language]="'json'"></code>
</pre>

    <h3>Step 5: SCSS helper import</h3>
    <p>
        If you are writing SCSS and want css variable names from a shared map,
        import the styling helper file.
    </p>
    <pre><code [highlight]="scssHelperSnippet" [language]="'css'"></code></pre>
    <p>
        Example using SCSS token maps for regular and inverse container colors:
    </p>
    <pre><code [highlight]="scssMapExampleSnippet" [language]="'css'"></code></pre>

    <h3>Step 6: Set the document theme</h3>
    <p>
        Set data-theme on the HTML element to switch between light and dark
        token values.
    </p>
    <pre><code [highlight]="themeSnippet" [language]="'typescript'"></code></pre>
</section>
